import { render, staticRenderFns } from "./VoiceAgentIcon.vue?vue&type=template&id=478bd69e"
import script from "./VoiceAgentIcon.vue?vue&type=script&lang=js"
export * from "./VoiceAgentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports